import BigNumber from 'bignumber.js';

const checkImageLoad = async (url) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => {
            console.warn(`Failed to load stock image: ${url}`);
            resolve(false);
        };
        img.src = url;
    });
};

const getStockRateInfo = (rateStart, rateEnd) => {
    let changeNum = new BigNumber(0);
    let minus = false;

    if (Number(rateStart)) {
        const startBN = new BigNumber(rateStart);
        const endBN = new BigNumber(rateEnd);
        changeNum = startBN.isZero() ? new BigNumber(0) : endBN.minus(startBN).dividedBy(startBN);
        minus = endBN.isLessThan(startBN);
    }

    let rate = '---';
    let rateNum = '0';
    if (Number(rateStart)) {
        rateNum = changeNum.multipliedBy(100).toFixed(2);
        rate = minus ? `${rateNum}%` : `+${rateNum}%`;
    }
    return {
        minus,
        rateNum,
        rate
    };
};
export { checkImageLoad, getStockRateInfo };
